import RequestedRugsModule from './RequestedRugsModule'
export default RequestedRugsModule
